<script>
import RolesAddDialog from './RolesAddDialog.vue'
import CredentialTable from '../common/CredentialsTable.vue'
import ToggleCredential from '../common/ToggleCredential.vue'

export default {
  components: {
    RolesAddDialog,
    CredentialTable,
    ToggleCredential
  },
  props: {
    value: {
      type: Array
    },
    loading: {
      type: Boolean
    }
  },
  data() {
    return {
      drawer: { state: false, data: {} },
      isDeletingRole: false,
      headers: [
        {
          text: this.$t('component.backoffice.rolesManagement.role'),
          align: 'start',
          value: 'role'
        },
        { text: this.$t('component.backoffice.rolesManagement.permissions'), value: 'permissions', sortable: false }
      ],
      credentials: { permissions: [] }
    }
  },
  methods: {
    openDrawer(event) {
      this.drawer.state = true
      this.drawer.data = event
      this.setCredentialState()
    },
    deleteRole() {
      this.$backofficeService.deleteRole(this.drawer.data.role)
        .then(async () => {
          this.$emit('deleted')
        })
        .catch()
        .finally(() => {
          this.drawer.state = false
          this.isDeletingRole = false
        })

    },
    updateRole(event) {
      // event.checked has the old, not changed, state
      // take the negotation to check the new state
      if (!event.checked) {
        this.drawer.data.permissions.push({
          permission: event.name
        })
      } else {
        let index = this.drawer.data.permissions.indexOf(
          this.drawer.data.permissions.find(
            permission => permission.permission === event.name
          )
        )
        this.drawer.data.permissions.splice(index, 1)
      }
      this.setCredentialState()
    },
    // sets the credential-state (roles and permissions) for the selected user
    setCredentialState() {
      // set state for permissions
      this.credentials.permissions = Object.values(
        this.$enums.permissions
      ).reduce((acc, value) => {
        acc.push({
          name: value,
          checked: this.drawer.data.permissions.find(
            permission => permission.permission === value
          )
            ? true
            : false
        })
        return acc
      }, [])
    }
  }
}
</script>
<template>
  <div>
    <RolesAddDialog @saved="$emit('added')" />
    <v-sheet class="overflow-hidden" style="position: relative">
      <v-data-table
        :headers="headers"
        :items="value"
        :items-per-page="15"
        :loading="loading"
        :loading-text="$t('component.backoffice.rolesManagement.loading')"
        :footer-props="{
            'items-per-page-text': $t('global.items.per.page.text'),
            'items-per-page-all-text': $t('global.items.per.page.all.text'),
            'page-text': $t('global.page.text'),
            'items-per-page-options': [25, 50, 100],
            'show-current-page': true,
            'show-first-last-page': true,
          }"
        class="elevation-1"
        style="cursor: pointer"
        @click:row="openDrawer">
        <template #[`item.role`]="{ item }">
          <v-tooltip top>
            <template #activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">{{ item.role }}</span>
            </template>
            <span>ID: {{ item.roleId }}</span>
          </v-tooltip>
        </template>
        <template #[`item.permissions`]="{ item }">
          <v-chip
            v-for="permission in item.permissions"
            :key="permission.permissionId"
            color="primary"
            class="ma-1" >
            <v-tooltip top>
              <template #activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">{{
                    permission.permission
                  }}</span>
              </template>
              <span>ID: {{ permission.permissionId }}</span>
            </v-tooltip>
          </v-chip>
        </template>
      </v-data-table>
      <v-navigation-drawer
        v-model="drawer.state"
        width="540"
        temporary
        right
        app >
        <div v-if="drawer.state" class="ml-4 mr-4">
          <v-card dense flat>
            <v-card-title class="pl-0 pb-0"
            ><b>{{ drawer.data.role }}</b></v-card-title  >
            <v-divider></v-divider>
            <div class="pb-8"></div>
          </v-card>
          <CredentialTable :items="credentials.permissions">
            {{$t('component.backoffice.rolesManagement.permissions')}}
            <template #item="slotProps">
              <ToggleCredential
                :credential="slotProps.credential"
                :role="drawer.data.role"
                :payload="{
                  roleName: drawer.data.role,
                  permission: slotProps.credential.name }"
                @change="updateRole(slotProps.credential)"/>
            </template>
          </CredentialTable>
          <v-divider></v-divider>
          <v-btn
            v-if="!isDeletingRole"
            color="error"
            block
            expand
            @click="isDeletingRole = !isDeletingRole">
            {{$t('component.backoffice.rolesManagement.delete.role')}}
          </v-btn>
          <div v-else>
            <small class="text-center d-block">{{$t('component.backoffice.rolesManagement.are.you.sure')}}</small>
            <v-row>
              <v-col>
                <v-btn color="primary" block expand @click="deleteRole">Ja</v-btn>
              </v-col>
              <v-col>
                <v-btn color="gray" block expand @click="isDeletingRole = false">{{$t('global.no')}}</v-btn>
              </v-col>
            </v-row>
          </div>
          &nbsp;
        </div>
      </v-navigation-drawer>
    </v-sheet>
  </div>
</template>